import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'tr[app-user-list-item]',
	templateUrl: './user-list-item.component.html',
	styleUrls: ['./user-list-item.component.scss']
})
export class UserListItemComponent {
	@Input() userData;
	@Output() output = new EventEmitter();

	showToolbar = false;

	constructor() {}

	deleteUser(userId) {
		this.output.emit({ method: 'delete', userId: userId });
	}

	unlockUser(userId) {
		this.output.emit({ method: 'unlock', userId: userId });
	}

	workAsUser(user) {
		this.output.emit({ method: 'workAs', user: user });
	}

	editUser(user) {
		this.output.emit({ method: 'editUser', user: user });
	}

	deleteUserModal(user) {
		this.output.emit({ method: 'deleteUserModal', user: user });
	}
}
